import { render, staticRenderFns } from "./DisplayUnitField.vue?vue&type=template&id=78c9581c&lang=pug&"
import script from "./DisplayUnitField.vue?vue&type=script&lang=js&"
export * from "./DisplayUnitField.vue?vue&type=script&lang=js&"
import style0 from "./DisplayUnitField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c9581c')) {
      api.createRecord('78c9581c', component.options)
    } else {
      api.reload('78c9581c', component.options)
    }
    module.hot.accept("./DisplayUnitField.vue?vue&type=template&id=78c9581c&lang=pug&", function () {
      api.rerender('78c9581c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/DisplayUnitField.vue"
export default component.exports